import request from 'api/request';

export default function moveQuestionDownRoute({ courseId, field, index }) {
  return request({
    url: `/courses/${courseId}/${field}/${index}/down`,
    method: 'PUT',
  });
}
